const API_BASE = '/api/twilio';

class TwilioClient {
  async request(endpoint, options = {}) {
    const url = `${API_BASE}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      ...options,
    };

    if (options.body && typeof options.body === 'object') {
      config.body = JSON.stringify(options.body);
    }

    const response = await fetch(url, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}`);
    }

    return data;
  }

  // Basic Twilio
  async getStatus() { return this.request('/status'); }
  async getNumbers() { return this.request('/numbers'); }
  async getMessages(params = {}) {
    const searchParams = new URLSearchParams(params);
    return this.request(`/messages?${searchParams}`);
  }
  async sendMessage(messageData) {
    return this.request('/messages', { method: 'POST', body: messageData });
  }
  async getCalls(params = {}) {
    const searchParams = new URLSearchParams(params);
    return this.request(`/calls?${searchParams}`);
  }
  async initiateCall(callData) {
    return this.request('/calls', { method: 'POST', body: callData });
  }

  // Number Management
  async searchAvailableNumbers(params = {}) {
    const searchParams = new URLSearchParams(params);
    return this.request(`/available-numbers?${searchParams}`);
  }
  async purchaseNumber(data) {
    return this.request('/purchase-number', { method: 'POST', body: data });
  }
  async updateNumber(sid, data) {
    return this.request(`/numbers?sid=${sid}`, { method: 'PATCH', body: data });
  }
  async releaseNumber(sid) {
    return this.request(`/numbers?sid=${sid}`, { method: 'DELETE' });
  }

  // IVR Management
  async getIvrs() { return this.request('/ivrs'); }
  async getIvr(id) { return this.request(`/ivrs/${id}`); }
  async createIvr(data) { return this.request('/ivrs', { method: 'POST', body: data }); }
  async updateIvr(id, data) { return this.request(`/ivrs/${id}`, { method: 'PUT', body: data }); }
  async deleteIvr(id) { return this.request(`/ivrs/${id}`, { method: 'DELETE' }); }
}

export default new TwilioClient();